import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Menu } from '@softwaredev_cegeka/stix-core/dist/components'
import {
    debouncedLoadData,
    sortData,
    sortObjectToString,
} from 'src/utils/utils'
import './entityTable.scss'
import EntityTable from './EntityTable'
import { DataTableSortableHeader } from '@softwaredev_cegeka/stix-data-table'

/**
 * Services table content.
 * @param props
 * @returns {*}
 * @constructor
 */
function ServiceTable({
    data,
    loading,
    setParams,
    params,
    rowSelectHandler,
    history,
    deleteAction,
}) {
    let [sort, setSort] = useState({ column: null, direction: null })

    const columns = [
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'name' ? sort.direction : undefined
                        }
                        onSort={handleColumnSort('name')}
                    >
                        Name
                    </DataTableSortableHeader>
                )
            },
            accessor: 'name',
            width: '20%',
        },
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'namespace'
                                ? sort.direction
                                : undefined
                        }
                        onSort={handleColumnSort('namespace')}
                    >
                        Namespace
                    </DataTableSortableHeader>
                )
            },
            accessor: 'namespace',
            width: '20%',
        },
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'short_description'
                                ? sort.direction
                                : undefined
                        }
                        onSort={handleColumnSort('short_description')}
                    >
                        Short description
                    </DataTableSortableHeader>
                )
            },
            accessor: 'short_description',
            width: '40%',
        },
        {
            Header: () => null,
            id: 'menu',
            Cell: selectedRow => (
                <Menu.Option
                    contextMenu={[
                        {
                            name: 'Edit service',
                            icon: 'edit',
                            onClick: () => {
                                history.push(
                                    '/service-form/' +
                                        selectedRow.row.original.id
                                )
                            },
                        },
                        {
                            name: 'Remove',
                            icon: 'delete',
                            onClick: () => {
                                let r = window.confirm(
                                    `You are permanently removing service ${selectedRow.row.original.name}. Are you sure?`
                                )
                                if (r === true) {
                                    deleteAction(
                                        selectedRow.row.original.id,
                                        selectedRow.row.original.name
                                    )
                                }
                            },
                        },
                    ]}
                    icon={'actions-vert'}
                />
            ),
            width: '4%',
        },
    ]

    // if any column that is a relationship and not a direct property to the service object
    // gets added here, it shouldn't be passed in the handleGlobalFilter function
    const columnsToFilter = [
        {
            column: 'name',
            label: 'Name',
        },
        {
            column: 'namespace',
            label: 'Namespace',
        },
        {
            column: 'short_description',
            label: 'Short description',
        },
    ]

    const handleColumnSort = columnName => sortingDirection => {
        sortData(columnName, sortingDirection, params, setSort, setParams)
    }

    function handleFilterChange(entries) {
        // Reset to show al results after clear filters is clicked.
        if (entries.length === 0) {
            setParams({})
            return
        }

        const sortString = sortObjectToString(sort)

        // Update params with new selected filter and send them back to the route.
        entries.forEach(item => {
            Object.entries(item).forEach(([key, value]) => {
                params[key + '_like'] = value.toString()
            })
        })

        if (sortString) {
            params.sort = sortString
        }

        setParams(params)
    }

    function handleGlobalFilter(value) {
        // check all columns on entry
        columnsToFilter.forEach(col => {
            params[col.column + '_like'] = value.toString()
        })
        params.use_or = true
        debouncedLoadData(params, setParams)
    }

    return (
        <EntityTable
            loading={loading}
            data={data}
            columns={columns}
            onSingleRowSelect={selectedRowObj => {
                rowSelectHandler(selectedRowObj)
            }}
            columnsTofilter={columnsToFilter}
            onColumnFilter={handleFilterChange}
            onGlobalFilter={handleGlobalFilter}
        />
    )
}

export default withRouter(ServiceTable)
